var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.117 35.3574L60.8862 48.0557C60.8862 48.0557 60.5581 48.5967 60.2268 48.9344C59.733 49.4361 59.1937 49.7442 59.1937 49.7442L41.4171 59.8557C40.0006 60.6623 38.2659 60.6524 36.8559 59.8295L19.0468 49.4295C19.0468 49.4295 18.4491 49.1344 17.8026 48.3672C17.6272 48.1606 17.351 47.7213 17.3673 47.7344L39.1138 35.3574H39.117Z",
    fill: "#5E5ADB",
    className: "primary-500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1235 11.7115V35.3541L17.3706 47.7377C17.3706 47.7377 17.0327 47.1967 16.8573 46.4033C16.7273 45.8131 16.7501 45.1279 16.7501 45.1279V26.4689C16.7501 24.7967 17.6434 23.2557 19.0858 22.4328L36.5084 12.5016C36.5084 12.5016 37.2166 12.0525 37.902 11.8689C38.5323 11.7016 39.1235 11.7115 39.1235 11.7115Z",
    fill: "#807CEA",
    className: "primary-400"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1235 11.7115V35.3541L60.8863 48.0557C60.8863 48.0557 61.1234 47.6525 61.2956 47.1279C61.5425 46.3869 61.5133 45.5934 61.5133 45.5934V26.7541C61.5068 25.0984 60.6329 23.5672 59.2132 22.7377L41.5438 12.423C41.5438 12.423 40.9558 12.059 40.397 11.9016C39.6271 11.6852 39.1235 11.7115 39.1235 11.7115Z",
    fill: "#B9B6FA",
    className: "primary-200"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.273 43.3213V15.1934L52.248 0V8.33443L70.9895 19.2656V39.0623L78.2763 43.318L78.273 43.3213Z",
    fill: "#B9B6FA",
    className: "primary-200"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1301 79L65.3272 64.0951L58.1184 59.8885L39.1333 70.6951L22.0876 60.7443L18.7935 62.6164L14.8756 64.8426L39.1268 79H39.1301Z",
    fill: "#5E5ADB",
    className: "primary-500"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 43.3279V14.7771L25.9697 0V8.64262L7.28673 19.2754V39.1803L0 43.3279Z",
    fill: "#807CEA",
    className: "primary-400"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignet);
export default __webpack_public_path__ + "static/media/signet.b7506fc7.svg";
export { ForwardRef as ReactComponent };